<template>
  <div class="home-container">
    <div class="home-left-container">
      <div class="sign-up" :style="ishidden ? 'height:389px' : 'height:600px'">
        <!-- Title ( 考试批次名称 )-->
        <div class="sign-up-title" v-if="!ishidden">{{ planInfo.name }}</div>
        <div class="sign-up-title2" v-else>报考流程图</div>
        <!-- ---------------------- 空状态 -------------------------------- -->
        <div class="sign-up-step" v-if="ishidden">
          <ul class="step-list">
            <li class="step-item">
              <div class="step-img">
                <img src="../../../assets/stuImg/step-1-s.png" />
              </div>
              <div class="step-name">报名</div>
            </li>
            <li class="step-item-spot">
              <div class="spot"></div>
              <div class="spot"></div>
              <div class="spot"></div>
            </li>
            <li class="step-item">
              <div class="step-img">
                <img src="../../../assets/stuImg/step-2-s.png" />
              </div>
              <div class="step-name">审核资格</div>
            </li>
            <li class="step-item-spot">
              <div class="spot"></div>
              <div class="spot"></div>
              <div class="spot"></div>
            </li>
            <li class="step-item">
              <div class="step-img">
                <img src="../../../assets/stuImg/step-3-s.png" />
              </div>
              <div class="step-name">缴费</div>
            </li>
            <li class="step-item-spot">
              <div class="spot"></div>
              <div class="spot"></div>
              <div class="spot"></div>
            </li>
            <li class="step-item">
              <div class="step-img">
                <img src="../../../assets/stuImg/step-4-s.png" />
              </div>
              <div class="step-name">打印准考证</div>
            </li>
            <li class="step-item-spot">
              <div class="spot"></div>
              <div class="spot"></div>
              <div class="spot"></div>
            </li>
            <li class="step-item">
              <div class="step-img">
                <img src="../../../assets/stuImg/step-5-s.png" />
              </div>
              <div class="step-name">考试</div>
            </li>
            <li class="step-item-spot">
              <div class="spot"></div>
              <div class="spot"></div>
              <div class="spot"></div>
            </li>
            <li class="step-item">
              <div class="step-img">
                <img src="../../../assets/stuImg/step-6-s.png" />
              </div>
              <div class="step-name">成绩查询</div>
            </li>
          </ul>
          <!-- 审核提示 -->
          <div class="auditStatus" v-if="true">
            <p>当前没有可以报名的考试批次，请等待</p>
          </div>
        </div>
        <!-- ---------------------- 竖式步骤条 start ----------------------- -->
        <div style="height: 300px" class="sign-up-step" v-else>
          <el-steps direction="vertical" :active="auditStep">
            <!-- 是否显示"审核流程" -->
            <!-- 
              item.step == 3 ? needPayment == 1 : item.step == 4 ? planInfo.downloadEntrance == 1 : item.step == 2 && planInfo.needAudit == 0 ? false : true
              :class="planInfo.allowViewExamScoreFlag === 1 && item.step == 5 ? 'isHiddenLine': ''"
             -->
            <el-step
              v-for="(item, index) in audit"
              :key="index"
              v-show="isShowStep(item)"
            >
              <!-- title 插槽 ( computed ) -->
              <template slot="title">
                <img :src="isSignUp ? item.img : item.stuImg" v-if="item.isImg == 'isSignUp'"/>
                <img :src="isAudit ? item.img : item.stuImg" v-if="item.isImg == 'isAudit'"/>
                <img :src="isPay ? item.img : item.stuImg" v-if="item.isImg == 'isPay'"/>
                <img :src="isPrint ? item.img : item.stuImg" v-if="item.isImg == 'isPrint'"/>
                <img :src="isExam ? item.img : item.stuImg" v-if="item.isImg == 'isExam'"/>
                <img :src="isQuery ? item.img : item.stuImg" v-if="item.isImg == 'isQuery'"/>
              </template>
              <!-- description 插槽 -->
              <template slot="description">
                <div class="des">
                  <div class="des-title">{{ item.des_title }}</div>
                  <!-- 显示各阶段的时间，若当前时间在某时间内里则黄色字显示时间，并显示可操作按钮。-->
                  <div class="des-data">
                    {{ item.des_data }}
                    <span :style="item.step == auditStep ? 'color:#F27900' : ''">{{ item.time }}</span>
                  </div>
                </div>
         
                <el-button
                  type="primary"
                  class="to-pay"
                  size="small"
                  v-if="item.status"
                  @click="item.btnUrl"
                >{{ item.nextStep }}</el-button>
                <!-- 按钮显示 ？ 提示显示 ？ -->
                <div
                  class="des-adopt"
                  v-if="item.title_status"
                  @click="item.desUrl"
                >
                  <img
                    src="../../../assets/img/pass.png"
                    alt=""
                    v-if="item.isAuditClass"
                  />
                  <img src="../../../assets/img/unpass.png" alt="" v-else />
                  <p :class="{ unpass: !item.isAuditClass }">
                    {{ item.title }}
                  </p>
                </div>
              </template>
            </el-step>
          </el-steps>
        </div>
        <!-- ---------------------- 竖式步骤条 end ----------------------- -->
      </div>
      <!-- 底部--公告 -->
      <div class="sign-bottom" v-if="noticeInfo.length">
        <div class="sign-bottom-top">
          <span>院校公告</span>
          <a href="javascript:void(0);" @click="goNotice">更多</a>
        </div>
        <div class="sign-bottom-main">
          <ul>
            <li v-for="(item, index) in noticeInfo" :key="index">
              <div
                :class="[
                  item.isRead == 'true' ? 'is_notice' : '',
                  'noticeBorder',
                ]"
              >
                <a href="javascript:void(0);" @click="Notice(item.id)">{{
                  item.title
                }}</a>
                <!-- 鼠标悬浮样式 -->
                <div class="noticeHover">{{ item.title }}</div>
                <!-- 隐藏下载链接 -->
                <span
                  @click="downloadNotice(item.id)"
                  style="color: red"
                  v-if="false"
                  >icon</span
                >
              </div>
              <span class="sign-bottom-main-data">{{ item.releaseTime }}</span>
            </li>
          </ul>
        </div>
      </div>
      <ots-custom-dialog
        :dialog.sync="paperDialog"
        title="公告提示"
        width="60%"
      >
        <template v-slot:content>
          <h1 style="text-align: center">{{ alertInfo.title }}</h1>
          <p
            v-html="alertInfo.content"
            style="text-indent: 2rem; margin-top: 16px"
            class="returnP"
          ></p>
        </template>
      </ots-custom-dialog>
    </div>

    <!-- 右侧用户个人信息  -->
    <div class="stu-info">
      <div class="stu-header">
        <div class="stu-avatarurl">
          <img :src="getAvatarUrl" alt="" />
        </div>
        <div class="stu-name-of-card">
          <div class="stu-name">{{ info.realName }}</div>
          <div class="card-id">
            <!-- 证件号：{{ info.cardNo }} -->
            <p>证件号：</p>
            <p>{{ info.cardNo }}</p>
          </div>
        </div>
      </div>
      <div class="school-info">
        <div class="school-info-title">院校信息</div>
        <ul class="school-info-list">
          <li class="school-info-item">
            <span class="info-label">就读院校：</span>
            <span class="info-value">{{ info.schoolId }}</span>
          </li>
          <li class="school-info-item">
            <span class="info-label">{{ ischangchun }}</span>
            <span class="info-value">{{ info.stationId }}</span>
          </li>
          <!-- 自定义院校信息 -->
          <li class="school-info-item" v-for="(item, key) in schoolInfoExt" :key="key">
            <span class="info-label">{{ item.displayName + "：" }}</span>
            <span class="info-value">{{ item.value }}</span>
          </li>
        </ul>

        <div style="width: 100%;">
          <img src="@/assets/img/WxQRCode.jpeg" alt="" style="margin: 0 auto;display: block;">
          <p style="text-align: center; font-size: 13px; color: #9299A6;">扫码关注公众号，及时接收最新考试信息推送</p>
        </div>

      </div>
      <!-- 靠前模拟下载 -->
      <a class="simulation" href="#" @click="isGoMoko()" v-if="isMoko">
        <div class="box">
          <div>
            <p class="f17 col_blue fb">考前模拟</p>
            <p class="f12 col_grayQ mt5">软件安装、考试环境调试</p>
          </div>
          <div class="linkBtn">
            <span class="mr3">立即体验</span>
            <img
              src="../../../assets/img/go.png"
              alt=""
              width="14px"
              height="14px"
            />
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
// import { getSessionListApi } from "@/http/modules/examSet/examActivity";
import { getSinglePlan } from "@/http/modules/examSet/examBatch";
import { goOtsStartExam } from "@/http/modules/student/exam";
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
import { selectByOne } from "@/http/modules/custom";
import {
  selectNoticeListInfo,
  selectNoticeByIdInfo,
} from "@/http/modules/student/notice";
import { checkStudentSignPlanExclusiveAPI } from "@/http/modules/student/batch";

export default {
  name: "home",
  props: ["userInfo", "schoolInfo"],
  data() {
    return {
      // importantDialog: window.localStorage.getItem("tenant") == "cczyy" ? true : false,
      ischangchun: "",
      info: this.userInfo,
      planInfo: {},
      /**
       * audit *****
       * step : 步骤,相当于id
       * img : 高亮图片
       * stuimg : 暗色图片
       * des_title : 流程标题
       * des_data : 冒号左侧数据
       * isImg : 高亮/暗色图片选择
       * btnUrl : 按钮链接
       * desUrl : 文字链接
       * time : 冒号右侧时间
       * nextStep : 按钮内文字
       * status : 是否开启按钮的开关
       * title_status : 是否开启提示
       * title : 按钮消失的绿色文字提示
       * isAuditClass : 是否显示未通过样式
       */
      audit: [
        {
          step: 1,
          img: require("../../../assets/img/quickFunImg001.png"),
          stuImg: require("../../../assets/stuImg/step-01-n.png"),
          des_title: "报名",
          des_data: "报名起止时间：",
          isImg: "isSignUp",
          btnUrl: this.goStuApply,
          desUrl: "",
          time: "",
          nextStep: "去报名",
          status: false,
          title_status: "",
          title: "报名已提交",
          isAuditClass: true,
        },
        {
          step: 2,
          img: require("../../../assets/img/quickFunImg002.png"),
          stuImg: require("../../../assets/stuImg/step-02-n.png"),
          des_title: "报名资格审核",
          des_data: "报名提交后，院校老师会尽快为您审核。",
          isImg: "isAudit",
          btnUrl: this.goExamine,
          desUrl: this.isNullAttr,
          time: "",
          nextStep: "审核信息",
          status: false,
          title_status: "",
          title: "审核已通过",
          isAuditClass: true,
        },
        {
          step: 3,
          img: require("../../../assets/img/quickFunImg003.png"),
          stuImg: require("../../../assets/stuImg/step-03-n.png"),
          des_title: "缴费",
          des_data: "缴费起止时间：",
          isImg: "isPay",
          btnUrl: this.goPay,
          desUrl: this.isNullAttr,
          time: "",
          nextStep: "去缴费",
          status: false,
          title_status: "",
          title: "您已缴费",
          isAuditClass: true,
        },
        {
          step: 4,
          img: require("../../../assets/img/quickFunImg004.png"),
          stuImg: require("../../../assets/stuImg/step-04-n.png"),
          des_title: "打印准考证",
          des_data: "准考证打印时间：",
          isImg: "isPrint",
          btnUrl: this.goPrint,
          desUrl: this.isNullAttrlse,
          time: "",
          nextStep: "去打印",
          status: true,
          title_status: "",
          title: "时间未到",
          isAuditClass: true,
        },
        // el-step__head is-wait
        {
          step: 5,
          img: require("../../../assets/img/quickFunImg005.png"),
          stuImg: require("../../../assets/stuImg/step-05-n.png"),
          des_title: "考试",
          des_data: "考试计划时间：",
          isImg: "isExam",
          btnUrl: this.startExam,
          desUrl: this.isNullAttr,
          time: "",
          nextStep: "去考试",
          status: true,
          title_status: "",
          title: "时间未到",
          isAuditClass: true,
        },
        {
          step: 6,
          img: require("../../../assets/img/quickFunImg006.png"),
          stuImg: require("../../../assets/stuImg/step-06-n.png"),
          des_title: "成绩查询",
          des_data: "查询开始时间：",
          isImg: "isQuery",
          btnUrl: this.queryScore,
          desUrl: this.isNullAttr,
          time: "",
          nextStep: "去查询",
          status: true,
          title_status: "",
          title: "时间未到",
          isAuditClass: true,
        },
      ],
      // 当前所在步骤( 进行到第几步 )
      auditStep: 1,
      // 当前的批次信息( 标题 )
      titleName: "",
      // 获取用户审核信息 api ( selectOneSignUp ) 参数
      planId: "",
      // 是否显示横版流程图
      ishidden: false,
      // 院校公告列表
      noticeInfo: "",
      // 展示弹出层
      paperDialog: false,
      // 弹出列表
      alertInfo: [],
      signUpInfo: [],
      // 首页--右侧院校信息
      schoolInfoExt: this.schoolInfo,
      // 历史批次ID
      lastPlanId: "",
      // 展示批次是否使用历史批次
      isUseLastPlan: false,
      // 考生是否在批次范围内
      isPlanRegion: 0,
      // 考生是否展示缴费流程条
      needPayment: "",
      // 当前时间
      currentTime: "",
      needExamOrderCode: "",
      // 场次列表
      sessionList: [],
    };
  },
  watch: {
    "signUpInfo.flag": function () {
      this.$emit("home-flag", this.signUpInfo.flag);
    },
    planInfo: function () {
      this.$emit("home-planInfo", this.planInfo);
    },
    
    // "needPayment" : function(val) {
    //   this.$emit('home-needPayment', this.needPayment);
    // },
    userInfo: function () {
      this.info = this.userInfo;
    },
    schoolInfo: function () {
      this.schoolInfoExt = this.schoolInfo;
    },
  },
  async created() {
    if (!this.getCurrentGlobalPlanId()) {
      this.ishidden = true;
    } else {
      // 获取当前场次信息
      // await this.getSessionList();

      this.isSetState();
      // 公告列表
      this.getNotice();
      // 弹窗公告
      this.getAlertNotice();
      // 获取当前批次信息
      await this.getCurrentPlan();
    }
    // 是否配置了教学点标题
 
    // 获取当前时间戳
    this.getCurrentTime();
  },
  mounted() {
    // if (this.$route.query.cpwd == "IsChange") {
    //   this.$message.warning(
    //     "您当前的密码安全性较低，可前往“账号设置”修改密码！"
    //   );
    // }
  },
  updated() {
    // 流程改变, 修改首页样式
    this.changeBgc();
  },
  methods: {
    /* ** getCurrentTime(获取当前时间) ** */
    getCurrentTime() {
      this.mixin_getServerTime().then(({ data }) => {
        this.currentTime = new Date(
          data ? data.replace(/\-/g, "/") : ""
        ).getTime();
      });
    },

    /***********************************
     * @isSetState 系统是否设置了教学点标题
     ***********************************/
    isSetState() {
      this.$api.system.getConfigData().then((res) => {
        let stationName = "";
        res.data.configList.map((e) => {
          if (e.setName == "stationName") {
            stationName = e.setValue2;
          }
          if (e.setName == "needExamOrderCode") {
            this.needExamOrderCode = e.setValue;
          }
          // else if (e.setName == 'needPayment') {
          //   this.needPayment = e.setValue;
          // }
        });
        this.ischangchun = stationName ? stationName + "：" : "教学点：";
      });
    },

    /****************************
     * @this 模考链接
     ****************************/
    async isGoMoko() {
      let param = {
        action: "StartTestNormal",
        parames: `arrangementId=${this.signUpInfo.arrangementId}`,
      };
      const { code, data } = await goOtsStartExam(param);
      if (code == 1) {
        window.open(data);
      }
    },

    /*******************************************
     * @getSignTime 报名开始/结束时间
     *******************************************/
    getSignTime() {
      /* ** flag: 用户报名状态 ** */
      let { flag } = this.signUpInfo;
      /* ** beginSign: 报名开始时间 -- endSign: 报名结束时间 ** */
      let { beginSign, endSign } = this.planInfo;
      /* ** 为了兼容Apple, mac等, 此处将 YYYY-MM-DD 格式转化为 YYYY/MM/DD 格式 ** */
      beginSign = beginSign ? beginSign.replace(/\-/g, "/") : "";
      endSign = endSign ? endSign.replace(/\-/g, "/") : "";
      /* ** 时间格式 -> 毫秒字符串 -> 用于判定报名状态 ** */
      let currentTime = this.currentTime;
      beginSign = new Date(beginSign).getTime();
      endSign = new Date(endSign).getTime();
      return {
        currentTime,
        beginSign,
        endSign,
        flag,
      };
    },

    /****************************
     * @this 各个流程按钮点击事件
     ****************************/
    isNullAttr() {
      return false;
    },

    async goStuApply() {
      if (this.isGoSignUp) {
        let params = {
          userId: JSON.parse(window.localStorage.getItem("userInfo")).id,
          willPlanId: this.getCurrentGlobalPlanId()
        }
        const { code } = await checkStudentSignPlanExclusiveAPI(params);
        if (code !== 1) {
          return false;
        } else {
          this.$router.push("/stuHome/stuApply");
        }
      } else {
        this.$message.warning("您不在当前报名范围内，请联系院校老师！");
      }
    },
    goExamine() {
      if (this.isGoAudit) {
        this.$router.push("/stuHome/stuExamine");
      }
    },
    goPay() {
      if (this.isGoPay) {
        this.$router.push("/stuHome/payFee");
      }
    },
    goPrint() {
      if (this.isPrint) {
        this.$router.push("/stuHome/ticket");
      }
    },
    startExam() {
      if (this.isExam) {
        this.$router.push("/stuHome/exam");
      }
    },
    queryScore() {
      if (this.isQuery) {
        this.$router.push("/stuHome/score");
      }
    },

    /***********************************
     * @this 处理时间格式--传入字符串
     ***********************************/
    processingTime(time) {
      var newTime = time.replace("-", "年");
      var newTime = newTime.replace("-", "月");
      return newTime.slice(0, 10) + "日" + newTime.slice(10);
    },

    // async getSessionList() {
    //   const { data } = await getSessionListApi({planId: this.getCurrentGlobalPlanId()});
    //   this.sessionList = data;
    // },


    /***********************************
     * @this 获取报考流程数据,处理时间数据(1)
     ***********************************/
    async getCurrentPlan() {
      selectByOne().then((res) => {
          return getCurrentPlanFn({
            cardNo: res.data.cardNo,
            planId: this.getCurrentGlobalPlanId(),
          });
        }).then(({ data }) => {
          if (!data) {
            sessionStorage.removeItem('planId');
            this.$router.push({ path: "/stuHome/batch" });
            return;
          }
          // 批次信息
          this.planInfo = data;
          // 批次是否配置缴费
          this.needPayment = data.isPay;
          // 考生是否在批次范围内
          this.isPlanRegion = data.isPlanRegion;
          // 展示批次是否为历史批次
          this.isUseLastPlan = false;
          // 历史批次信息加入至批次信息
          this.planInfo.isUseLastPlan = false;

          /* ** 2022/08/04 系统设置未开启缴费, 处理缴费相关字段 (null 转化为 '') ** */
          for (let key in data) {
            if (data[key] == null) {
              data[key] = "";
            }
          }

          this.audit[0].time = this.processingTime(data.beginSign) + " ~ " + this.processingTime(data.endSign);
          this.audit[2].time = this.needPayment == 1 ? this.processingTime(data.startPay) + " ~ " + this.processingTime(data.endPay) : "";

          // let sessionEndTime = this.sessionList[this.sessionList.length - 1].endTime;
          this.audit[3].time = data.downloadEntrance == 1 ? this.processingTime(data.beginEntrance) + " ~ " + this.processingTime(data.endExam) : "";

          this.audit[4].time = this.processingTime(data.beginExam) + " ~ " + this.processingTime(data.endExam);
          this.planInfo.examBeginAndEndCustomName = this.planInfo.examBeginAndEndCustomName ? this.planInfo.examBeginAndEndCustomName: "考试";
          this.audit[4].des_title = this.planInfo.examBeginAndEndCustomName;
          // this.audit[4].des_data = this.planInfo.examBeginAndEndCustomName + "起止时间：";
          this.audit[4].des_data = "计划时间：";
          this.audit[5].time = this.processingTime(data.beginScoreCheck);
          let userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
          return this.$api.applyManage.selectOneSignUp({
            planId: this.planInfo.id,
            stuIds: userInfo.id,
          });

        }).then((res) => {
          this.info.photo = res.data.photoUrl;
          this.signUpInfo = res.data;
          let { beginSign, endSign } = this.planInfo;
          beginSign = beginSign ? beginSign.replace(/\-/g, "/") : "";
          endSign = endSign ? endSign.replace(/\-/g, "/") : "";
          let currentTime = this.currentTime;
          let beginSignTime = new Date(beginSign).getTime();
          let endSignTime = new Date(endSign).getTime();
          // 1. 未在当前时间内, 并且未报名
          // 2. 是否有上一个批次: 有=>显示 没有=>横版流程图
          if (
            (currentTime < beginSignTime || currentTime > endSignTime) &&
            res.data.flag == 0
          ) {
            // if (res.data.lastPlanId) {
            //   this.isProcess(res.data.lastPlanId);
            // } else {
            //   this.ishidden = true;
            // }
          } else {
            this.ishidden = false;
          }

          if (res.data.flag == 3 || res.data.flag == 4) {
            this.audit[1].des_data = "审核未通过：";
            this.audit[1].time = res.data.reason;
          } else {
            this.audit[1].des_data = "报名提交后，院校老师会尽快为您审核。";
            this.audit[1].time = "";
          }

          // 2023年11月20日 缴费状态
          const { data } = res;
          this.audit[2].title = data.refundPayFlag == 1 ? "已退费": "您已缴费";

        });
    },

    /***********************************
     * @this 用户有上一批次的信息,修改相关信息(3)
     * @planId : 上一批次的id
     ***********************************/
    isProcess(planId) {
      // 1. 修改信息为上一批次
      getSinglePlan({ planId: planId })
        .then((res) => {
          // 查询到的批次信息
          this.planInfo = res.data;

          // 缴费信息
          this.needPayment = res.data.isPay;

          // 展示信息是否为上一批次信息
          this.isUseLastPlan = true;

          // 是否历史批次信息,加入批次信息
          this.planInfo.isUseLastPlan = true;

          // 考生是否符合范围
          this.planInfo.isPlanRegion = 0;

          /* ** 2022/08/04 系统设置未开启缴费, 处理缴费相关字段 (null 转化为 '') ** */
          for (let key in res.data) {
            if (res.data[key] == null) {
              res.data[key] = "";
            }
          }

          this.audit[0].time =
            this.processingTime(res.data.beginSign) +
            " ~ " +
            this.processingTime(res.data.endSign);
          this.audit[2].time =
            this.needPayment == 1
              ? this.processingTime(res.data.startPay) +
                " ~ " +
                this.processingTime(res.data.endPay)
              : "";
          this.audit[3].time =
            res.data.downloadEntrance == 1
              ? this.processingTime(res.data.beginEntrance)
              : "";
          this.audit[4].time =
            this.processingTime(res.data.beginExam) +
            " ~ " +
            this.processingTime(res.data.endExam);
          this.audit[5].time = this.processingTime(res.data.beginScoreCheck);

          let userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
          return this.$api.applyManage.selectOneSignUp({
            planId: planId,
            stuIds: userInfo.id,
          });
        })
        .then((res) => {
          this.info.photo = res.data.photoUrl;
          this.signUpInfo = res.data;
          // 2. 获取上一批次 flag
          this.signUpInfo.flag = res.data.flag;
          // 3. 有上一批次信息, 不显示横版流程图
          this.ishidden = false;
        });
    },

    /***********************************
     * @this 改变当前选中背景(ele内置元素)
     ***********************************/
    changeBgc() {
      let bgc = document.querySelectorAll(".el-step__main");
      if (bgc) {
        bgc.forEach((e, i) => {
          if (i == this.auditStep - 1) {
            e.style.backgroundColor = "#F4F5F8";
          } else {
            e.style.backgroundColor = "#fff";
          }
        });
      }

      setTimeout(() => {
        let DOMS= document.querySelectorAll(".el-step");
        let i = 0;
        DOMS.forEach((e,k)=>{
          if (e.style.display == "none") {
            i++;
          }
        })

        let newDOMS = [];
        let m = 5-i;

        DOMS.forEach((e,k)=>{
          if (e.style.display != "none") {
            newDOMS.push(e);
          }
        })

        newDOMS[m].classList.add('isHiddenLine');
      }, 1000);
    },

    /************************************
     * @this 报名流程条链接
     * @step : 流程进度(1~6)
     * @flag : 对应流程进度的状态
     * 注 : 有按钮流程条不可点击,无按钮可点击(涉及流程[1,2,3])
     ************************************/
    isClick(step, flag) {
      let _this = this;
      let step_main = document.querySelectorAll(".el-step__main")[step];
      // step=0(报名流程) flag=1(报名/修改)
      if (this.isGoSignUp && step == 0 && flag == 1) {
        step_main.style.cursor = "pointer";
        step_main.addEventListener("click", function () {
          _this.$router.push("/stuHome/stuApply");
        });
      }
      // step=0(报名流程) flag=2(查看报名信息)
      // if (this.isGoAudit && step == 0 && flag == 2) {
      if (step == 0 && flag == 2) {
        step_main.style.cursor = "pointer";
        step_main.addEventListener("click", function () {
          _this.$router.push("/stuHome/stuExamine");
        });
      }
      // step=1(审核流程) flag=1(查看报名信息)
      // if (this.isGoAudit && step == 1 && flag == 1) {
      if (step == 1 && flag == 1) {
        step_main.style.cursor = "pointer";
        step_main.addEventListener("click", function () {
          _this.$router.push("/stuHome/stuExamine");
        });
      }
      // step=2(缴费流程) flag=1(查看缴费状态)
      if (step == 2 && flag == 1) {
        step_main.style.cursor = "pointer";
        step_main.addEventListener("click", function () {
          _this.$router.push("/stuHome/payFee");
        });
      }
    },

    /**********************************
     * @this 加载公告列表
     **********************************/
    getNotice() {
      let params = {
        isFrom: "04",
        planId: this.getCurrentGlobalPlanId(),
      };
      selectNoticeListInfo(params).then((res) => {
        if (res.code == 1) {
          this.noticeInfo = res.data;
        }
      });
    },

    /**********************************
     * @this 进入公告列表
     **********************************/
    goNotice() {
      this.$router.push("/stuHome/stuNotice");
    },

    /**********************************
     * @this 进入公告详情
     **********************************/
    Notice(e) {
      this.$router.push("/stuHome/stuNoticeInfo?id=" + e);
    },

    /*********************************
     * @this 获取弹窗数据
     *********************************/
    async getAlertNotice() {
      this.alertInfo = [];
      let params = {
        isFrom: "01",
        planId: this.getCurrentGlobalPlanId(),
      };
      const { data } = await selectNoticeListInfo(params);
      if (data.length > 0 && data[0].noticeShow != "0") {
        this.paperDialog = true;
        this.alertInfo = data[0];
        let par = {
          id: data[0].id,
          isFrom: "00",
        };
        // 标记已读
        selectNoticeByIdInfo(par);
        // 更新已读状态
        this.getNotice();
      } else {
        this.paperDialog = false;
      }
    },

    /**
     * @param { 是否退费 }
     */
    IsRefundPayFlag() {
      if (this.signUpInfo.refundPayFlag == 1) {
        this.audit[2].status = false;
        this.audit[2].title_status = true;
        this.isClick(2, 1);
      }
    },
    /**
     * @param { 流程显示 }
     * {item.step == 3 ? needPayment == 1 : item.step == 4 ? planInfo.downloadEntrance == 1 : item.step == 2 && planInfo.needAudit == 0 ? false : true}
     */
    isShowStep(item) {
      /* 
        allowViewExamScoreFlag
        allowViewExamTimeFlag
      */
      if (item.step == 3) {
        return this.needPayment == 1;
      } else if (item.step == 4) {
        return this.planInfo.downloadEntrance == 1;
      } else if (item.step == 5 && (this.planInfo.examTypeId == 4 || this.planInfo.allowViewExamTimeFlag === 1)) {
        return false;
      } else if (item.step == 2 && this.planInfo.needAudit == 0) {
        return false;
      } else if (item.step == 6 && this.planInfo.allowViewExamScoreFlag === 1) {
        return false;
      } else {
        return true;
      }
    },
  },
  computed: {
    /**********************************
     * @this 获取对应用户头像
     **********************************/
    getAvatarUrl() {
      let { photo } = this.info;
      if (photo) {
        return photo;
      }
      return require("../../../assets/stuImg/default-avatarurl.png");
    },

    /**********************************
     * @this 已经注册--等待报考--(是否能跳转到"去报名")
     * - 修改: 历史批次不可以报名, 即使在报名时间之内
     **********************************/
    isGoSignUp() {
      let { currentTime, beginSign, endSign, flag } = this.getSignTime();
      if (
        currentTime >= beginSign &&
        currentTime <= endSign &&
        (flag === 0 || flag === 1) &&
        !this.isUseLastPlan &&
        this.isPlanRegion == "1"
      ) {
        return true;
      } else {
        return false;
      }
    },

    /**********************************
     * @this 用户报名流程
     **********************************/
    isSignUp() {
      let { currentTime, beginSign, endSign } = this.getSignTime();
      let { flag } = this.signUpInfo;
      let { state } = this.planInfo;

      // 1. 报名时间内,用户已经注册,可以报考 ==> "去报名"
      if (currentTime >= beginSign && currentTime <= endSign && flag == 0) {
        this.audit[0].status = true;
        this.auditStep = 1;
        if (state === 0) {
          this.audit[0].status = false;
        }
        return true;
        // 2.报名时间内,报名信息未审核,可以修改报名信息 ==> "报名已提交" ==> "点击进入修改页面"
      } else if (
        currentTime >= beginSign &&
        currentTime <= endSign &&
        flag == 1
      ) {
        this.audit[0].status = false;
        this.audit[0].title_status = true;
        this.audit[0].title = "报名已提交";
        this.audit[0].desUrl = this.goStuApply;
        this.isClick(0, 1);
        if (state === 0) {
          this.audit[0].status = false;
        }
        return true;
        // 3.报名时间内,用户已经注册待审核 / 用户审核通过 ==> "报名已提交" ==> "点击进入查看页面"
      } else if (flag == 1 && currentTime >= endSign) {
        this.audit[0].title = "报名已提交";
        this.audit[0].title_status = true;
        this.isClick(0, 2);
        if (state === 0) {
          this.audit[0].status = false;
        }
        return true;
      } else if (flag > 1) {
        this.audit[0].status = false;
        this.audit[0].title_status = true;
        this.audit[0].title = "报名已提交";
        this.audit[0].desUrl = this.goExamine;
        this.auditStep = 2;
        this.isClick(0, 2);
        if (state === 0) {
          this.audit[0].status = false;
        }
        return true;
      } else {
        if (state === 0) {
          this.audit[0].status = false;
        }
        return false;
      }
    },

    /**********************************
     * @this 用户审核流程
     **********************************/
    isAudit() {
      let { flag } = this.signUpInfo;
      let { beginSign, endSign } = this.getSignTime();
      let { endAudit, state } = this.planInfo;
      endAudit = endAudit ? endAudit.replace(/\-/g, "/") : "";
      let currentTime = this.currentTime;
      let endAuditTime = new Date(endAudit).getTime();

      // 1.用户审核通过
      if (flag > 1 && flag != 3 && flag != 4) {
        this.audit[1].title_status = true;
        this.audit[1].title = "报名已审核";
        this.audit[1].status = false;
        this.auditStep = 3;
        this.audit[1].isAuditClass = true;
        this.isClick(1, 1);
        if (state === 0) {
          this.audit[1].status = false;
        }
        return true;
        // 2. 审核不通过,时间在报名时间内 && flag=3 ==> 可以修改
      } else if (
        currentTime > beginSign &&
        currentTime < endSign &&
        flag == 3
      ) {
        this.audit[1].status = true;
        this.audit[1].title_status = false;
        this.audit[1].nextStep = "去修改";
        if (state === 0) {
          this.audit[1].status = false;
        }
        return true;
        // 修改 : flag == 1 审核中,在终审时间之前 ==> 审核中
      } else if (currentTime < endAuditTime && flag == 1) {
        this.audit[1].status = true;
        this.audit[1].nextStep = "审核中";
        this.audit[1].title_status = false;
        this.auditStep = 2;
        //4.添加审核不通过样式
        this.audit[1].isAuditClass = true;
        this.isClick(1, 1);
        if (state === 0) {
          this.audit[1].status = false;
        }
        return true;
        // 修改 : flag == 1 , 终审时间过了 ==> 审核不通过
      } else if (currentTime > endAuditTime && flag == 1) {
        this.audit[1].status = false;
        this.audit[1].title_status = false;
        this.audit[1].title = "审核不通过";
        //4.添加审核不通过样式
        this.audit[1].isAuditClass = true;
        this.isClick(1, 1);
        if (state === 0) {
          this.audit[1].status = false;
        }
        return true;
        // 3.审核不通过,报名时间过了,审核不通过 || flag=4 ==> 不可以修改
      } else if ((currentTime > endSign && flag == 3) || flag == 4) {
        this.audit[1].status = false;
        this.audit[1].title_status = true;
        this.audit[1].title = "审核不通过";
        //4.添加审核不通过样式
        this.audit[1].isAuditClass = false;
        this.isClick(1, 1);
        if (state === 0) {
          this.audit[1].status = false;
        }
        return true;
      } else {
        if (state === 0) {
          this.audit[1].status = false;
        }
        return false;
      }
    },

    /**********************************
     * @this 审核通过待缴费/审核通过已缴费--(是否能跳转到"去缴费")
     **********************************/
    isGoPay() {
      let { flag } = this.signUpInfo;
      let { startPay, endPay } = this.planInfo;
      startPay = startPay ? startPay.replace(/\-/g, "/") : "";
      endPay = endPay ? endPay.replace(/\-/g, "/") : "";
      let currentTime = this.currentTime;
      let startPayTime = new Date(startPay).getTime();
      let endPayTime = new Date(endPay).getTime();
      // 缴费时间范围内, 才可以去缴费
      if ((flag === 2 || flag === 5) && currentTime < endPayTime && currentTime > startPayTime) {
        return true;
      } else {
        return false;
      }
    },

    /**********************************
     * @this 用户缴费流程
     **********************************/
    isPay() {
      let { flag } = this.signUpInfo;
      let { startPay, endPay, state } = this.planInfo;
      startPay = startPay ? startPay.replace(/\-/g, "/") : "";
      endPay = endPay ? endPay.replace(/\-/g, "/") : "";
      let currentTime = this.currentTime;
      let startPayTime = new Date(startPay).getTime();
      let endPayTime = new Date(endPay).getTime();

      // 1. 用户审核通过 ==> 待缴费/部分课程缴费(缴费截止时间内) ==> 去缴费
      if ( (flag == 2 || flag == 5) && currentTime < endPayTime && currentTime > startPayTime ) {
        this.audit[2].status = true;
        this.audit[2].title_status = false;
        if (state === 0) {
          this.audit[2].status = false;
        }
        this.IsRefundPayFlag();
        return true;
        // 2. 用户审核通过 ==> 用户缴费完成 ==> 报考已缴费
      } else if (flag == 6 || flag == 7) {
        this.audit[2].title_status = true;
        this.audit[2].title = "报考已缴费";
        this.audit[2].status = false;
        this.auditStep = 4;
        this.isClick(2, 1);
        if (state === 0) {
          this.audit[2].status = false;
        }
        this.IsRefundPayFlag();
        return true;
      } else if (currentTime > endPayTime) {
        this.audit[2].status = false;
        this.audit[2].title_status = false;
        if (state === 0) {
          this.audit[2].status = false;
        }
        this.IsRefundPayFlag();
        return true;
      }
    },

    /**********************************
     * @this 打印准考证流程
     **********************************/
    isPrint() {
      let { flag, isPayCourse } = this.signUpInfo;
      let { beginEntrance, endExam, state } = this.planInfo;

      beginEntrance = beginEntrance ? beginEntrance.replace(/\-/g, "/") : "";
      endExam = endExam ? endExam.replace(/\-/g, "/") : "";
      let currentTime = this.currentTime;
      let beginEntranceTime = new Date(beginEntrance).getTime();
      let endExamTime = new Date(endExam).getTime();

      // let endTime;
      // if (this.sessionList.length > 0) {
      //   let sessionEndTime = this.sessionList[this.sessionList.length - 1].endTime;
      //   endTime = new Date(sessionEndTime).getTime()
      // }
      // console.log("homeFlag", flag);

      // 1. 打印准考证 ==> 准考证打印时间已开始 && 考试截止时间未到 && 缴费完成 ==> 去打印
      if ((flag == 5 || flag == 6 || flag == 7 || (flag == 2 && isPayCourse == 1)) && currentTime >= beginEntranceTime && currentTime < endExamTime) {
        this.audit[3].status = true;
        this.title_status = false;
        this.auditStep = 4;
        if (state === 0) {
          this.audit[3].status = false;
        }
        return true;
      } else if (currentTime > beginEntranceTime) {
        this.audit[3].status = false;
        this.audit[3].title_status = false;
        if (state === 0) {
          this.audit[3].status = false;
        }
        return true;
      } else {
        this.audit[3].status = false;
        this.audit[3].title_status = false;
        if (state === 0) {
          this.audit[3].status = false;
        }
        return false;
      }
    },

    /**********************************
     * @this 开始考试流程
     **********************************/
    isExam() {
      let { flag } = this.signUpInfo;
      let { beginExam, endExam, state } = this.planInfo;
      beginExam = beginExam ? beginExam.replace(/\-/g, "/") : "";
      endExam = endExam ? endExam.replace(/\-/g, "/") : "";
      let currentTime = this.currentTime;
      let beginExamTime = new Date(beginExam).getTime();
      let endExamTime = new Date(endExam).getTime();

      // 1. 在当前考试时间内 && flag=7 ==> 去考试
      //  if ( flag == 7 && (currentTime > beginExamTime && currentTime < endExamTime) ) {
      if (this.needExamOrderCode == 0) {
        if (currentTime > beginExamTime && currentTime < endExamTime) {
          this.audit[4].status = true;
          this.auditStep = 5;
          if (state === 0) {
            this.audit[4].status = false;
          }
          return true;
          // 2. 不满足条件 ==> 不显示
        } else if (currentTime > endExamTime) {
          this.audit[4].status = false;
          this.audit[4].title_status = false;
          if (state === 0) {
            this.audit[4].status = false;
          }
          return true;
        } else {
          this.audit[4].status = false;
          this.audit[4].title_status = false;
          if (state === 0) {
            this.audit[4].status = false;
          }
          return true;
        }
      } else {
        if (currentTime > beginExamTime && currentTime < endExamTime) {
          this.audit[4].status = false;
          this.auditStep = 5;
          if (state === 0) {
            this.audit[4].status = false;
          }
          return true;
          // 2. 不满足条件 ==> 不显示
        } else if (currentTime > endExamTime) {
          this.audit[4].status = false;
          this.audit[4].title_status = false;
          if (state === 0) {
            this.audit[4].status = false;
          }
          return true;
        } else {
          this.audit[4].status = false;
          this.audit[4].title_status = false;
          if (state === 0) {
            this.audit[4].status = false;
          }
          return false;
        }
      }
    },

    /**********************************
     * @this 成绩查询流程
     **********************************/
    isQuery() {
      let { planClassId } = this.signUpInfo;
      let { beginScoreCheck, state } = this.planInfo;
      beginScoreCheck = beginScoreCheck
        ? beginScoreCheck.replace(/\-/g, "/")
        : "";
      let queryTime = new Date(beginScoreCheck).getTime();
      let currentTime = this.currentTime;
      if (currentTime >= queryTime && planClassId) {
        this.audit[5].status = true;
        this.auditStep = 6;
        return true;
      } else {
        this.audit[5].status = false;
        this.audit[5].title_status = false;
        return false;
      }
    },

    /**********************************
     * @this 资格审核
     **********************************/
    isGoAudit() {
      let { flag } = this.signUpInfo;
      let { endAudit } = this.planInfo;
      endAudit = endAudit ? endAudit.replace(/\-/g, "/") : "";
      let currentTime = this.currentTime;
      let endAuditTime = new Date(endAudit).getTime();
      if (flag > 0 && currentTime <= endAuditTime) {
        return true;
      }
      return false;
    },

    /**********************************
     * @this 能否模考
     **********************************/
    isMoko() {
      if (this.signUpInfo.arrangementId) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.school-info-item .info-value {
  line-height: 24px;
  white-space: pre-wrap;
  word-wrap: break-word;
  width: 184px;
}
// 公告弹窗
.returnP {
  width: 100%;
  word-break: break-all;
  word-wrap: break-word;
}
.alertNotice {
  li {
    padding: 0 8px;
    font-size: 14px;
    height: 58px;
    border-bottom: 1px #f1f2f5 dotted;
    display: flex;
    justify-content: space-between;
    border-radius: 8px;
    box-sizing: border-box;
    .alertNotice_a {
      display: inline-block;
      color: #fe5958 !important;
      line-height: 58px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      max-width: calc(100% - 60px);
    }
  }
  li:hover {
    background-color: #f4f5f8;
  }
}
/* ***** 竖式步骤条 start ***** */
.el-steps {
  height: 450px;

  .el-step {
    /deep/ .el-step__head {
      display: flex;
      justify-content: center;
      /* ** 小圆点(中心部分) ** */
      .el-step__icon {
        width: 10px;
        height: 10px;
        border-width: 3px;
        box-sizing: border-box;
        border-color: #dadde6;
        /* ** 圆点内部数字,隐藏 ** */
        .el-step__icon-inner {
          display: none;
        }
      }
      .el-step__line {
        background: #f1f2f5;
      }
    }
    /deep/ .el-step__head.is-finish {
      .el-step__icon {
        border-color: #0b66e6;
      }
    }
    /* *** 图标以及文字部分 *** */
    /deep/ .el-step__main {
      height: 74px;
      margin-left: 8px;
      margin-top: -37px;
      padding-left: 16px;
      border-radius: 8px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      /* ** 图标部分 ** */
      .el-step__title {
        width: 34px;
        height: 32px;
        box-sizing: border-box;
        padding: 0;
        img {
          width: 32px;
          height: 32px;
        }
      }
      /* ** 文字部分 ** */
      .el-step__description {
        padding: 0;
        margin: 0;
        width: 100%;
        margin-left: 12px;

        /* 标题 */
        .des {
          float: left;
          width: auto;
          .des-title {
            font-size: 14px;
            color: #45494d;
            font-weight: 500;
            font-family: PingFangSC-Medium, PingFang SC;
          }
          /* 时间描述 */
          .des-data {
            font-size: 13px;
            color: #9299a6;
          }
        }
        /* 按钮 */
        .to-pay {
          width: 90px;
          float: right;
          border-radius: 20px;
          margin-right: 24px;
          margin-top: 4px;
          font-size: 13px;
        }
        /* 审核通过样式 */
        .des-adopt {
          width: 82px;
          height: 20px;
          float: right;
          margin-top: 10px;
          margin-right: 24px;
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
          p {
            color: #1dbf60;
          }
          p.unpass {
            color: #fe5958;
          }
        }
      }
    }
  }

  .isHiddenLine.el-step {
    /deep/ .el-step__head {
      .el-step__line {
        display: none;
      }
    }
  }
}
/* ***** 竖式步骤条 end ***** */
.home-container:after {
  content: "";
  height: 0;
  clear: both;
  display: block;
  visibility: hidden;
}

.step-list {
  display: flex;
  justify-content: center;
  margin-top: 48px;
  .step-item-spot {
    display: flex;
    align-items: center;
    width: 10%;
    min-width: 48px;
    padding: 10px;
    box-sizing: border-box;
    justify-content: space-around;
    .spot {
      width: 6px;
      height: 6px;
      background: #dadde6;
      border-radius: 50%;
      margin-top: -28px;
    }
  }
  .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .step-img {
      width: 64px;
      height: 64px;
      img {
        width: 64px;
        height: 64px;
      }
    }
    .step-name {
      color: #45494d;
      font-size: 14px;
      margin-top: 10px;
      white-space: nowrap;
    }
  }
}
.auditStatus {
  height: 74px;
  background-color: #f4f5f8;
  margin-top: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding-left: 24px;
  p {
    color: #45494d;
    font-size: 14px;
  }
}
.home-container {
  width: 1240px;
  margin: 0 auto;
  .home-left-container {
    float: left;
    min-height: 480px;
    border-radius: 8px;
    /* ***** 报考流程 ***** */
    .sign-up {
      width: 900px;
      background: #fff;
      border-radius: 8px;
      padding: 30px 40px;
      box-sizing: border-box;
      /* ***** 标题左对齐 ***** */
      .sign-up-title {
        color: #2d2f33;
        font-size: 18px;
        font-weight: bold;
        text-align: left;
        margin-bottom: 53px;
      }
      .sign-up-title2 {
        height: 33px;
        line-height: 33px;
        color: #2d2f33;
        margin-top: 10px;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
      }
    }
    /* ***** 院校公告 ***** */
    .sign-bottom {
      width: 100%;
      height: auto;
      border-radius: 8px;
      background-color: #fff;
      margin-top: 24px;
      padding: 30px 40px;
      box-sizing: border-box;
      .sign-bottom-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 18px;
          color: #2d2f33;
          font-weight: 600;
        }
        a {
          text-decoration: none;
          color: #737780;
          font-size: 14px;
        }
      }
      .sign-bottom-main {
        ul {
          li {
            font-size: 14px;
            height: 58px;
            border-bottom: 1px #f1f2f5 dotted;
            display: flex;
            justify-content: space-between;

            .noticeBorder {
              width: 75%;
              height: 58px;
              display: flex;
              align-items: center;
              position: relative;

              a {
                display: inline-block;
                color: #45494d;
                line-height: 58px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                max-width: calc(100% - 60px);
              }

              .noticeHover {
                padding: 0 8px;
                width: auto;
                display: none;
              }

              /* ***** 鼠标悬浮显示全部内容 ***** */
              a:hover + .noticeHover {
                display: block;
                position: absolute;
                background-color: #eee;
                border: 1px solid #737780;
                border-radius: 4px;
                bottom: 100%;
                left: 16px;
              }

              span {
                margin-left: 8px;
                display: inline-block;
                cursor: pointer;
              }
            }

            .noticeBorder::before {
              content: "";
              display: inline-block;
              width: 5px;
              height: 5px;
              margin-right: 7px;
              background: #fe5958;
              border-radius: 50%;
            }

            .sign-bottom-main-data {
              color: #737780;
              float: right;
              line-height: 58px;
            }

            .is_notice {
              a {
                color: #9299a6;
              }
              span {
                color: #9299a6;
              }
            }

            .is_notice::before {
              content: "";
              display: inline-block;
              width: 5px;
              height: 5px;
              margin-right: 7px;
              background: #c2c6cc;
              border-radius: 50%;
            }
          }
        }
      }
    }
  }

  .stu-info {
    width: 320px;
    float: right;
    .stu-header {
      box-sizing: border-box;
      padding: 18px 30px;
      height: 108px;
      display: flex;
      background: url("../../../assets/stuImg/stu-info-header-bgc.png")
        no-repeat;
      background-size: 100% 100%;
      align-items: center;
      .stu-avatarurl {
        img {
          width: 72px;
          height: 72px;
          border-radius: 50%;
        }
      }
      .stu-name-of-card {
        padding-left: 16px;
        .stu-name {
          font-size: 20px;
          font-weight: bold;
        }
        .card-id {
          color: #737780;
          font-size: 13px;
          display: flex;
          flex-wrap: wrap;
        }
      }
    }
    .school-info {
      background: #fff;
      box-sizing: border-box;
      padding: 24px 28px;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      .school-info-title {
        color: #1a2b3e;
        font-size: 18px;
        font-weight: bold;
        line-height: 1;
      }
      .school-info-list {
        .school-info-item {
          width: 100%;
          display: flex;
          font-size: 14px;
          margin-top: 24px;
          line-height: 1;
          .info-label {
            display: inline-block;
            min-width: 80px;
            text-align: right;
            color: #9299a6;
            line-height: 24px;
          }
          .info-value {
            display: inline-block;
            color: #737780;
          }
        }
      }
    }
    .simulation {
      text-decoration: none;
      display: block;
      position: relative;
      width: 100%;
      height: 0;
      margin-top: 20px;
      padding-top: 27%;
      background-image: url("../../../assets/img/mockBg.png");
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 8px;
      cursor: pointer;
      .box {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4%;
        box-sizing: border-box;
        .linkBtn {
          background: linear-gradient(270deg, #ff8800 0%, #f26500 100%);
          border-radius: 15px;
          display: flex;
          align-items: center;
          font-size: 12px;
          padding: 4px 6px;
          color: #fff;
        }
      }
    }
  }
}

.sign-step-container {
  margin-top: 26px;
  .step-text {
    cursor: pointer;
    font-size: 14px;
    color: #737780;
    margin-bottom: 4px;
    .examine-state {
      font-size: 20px;
      font-weight: bold;
      margin-right: 16px;
    }
    .step-examine {
      .examine-state-text {
        color: #f27900;
      }
      .examine-error-state-text {
        color: #fe5958;
      }
      .examine-pass-state-text {
        color: #1dbf60;
      }
    }
    .tips-text {
      color: #45494d;
      font-weight: bold;
    }
    .sign-up-btn {
      font-weight: bold;
      color: #006aff;
      margin-left: 4px;
    }
  }
  .sign-step1 {
    background: #ebf2ff;
  }
  .sign-step2 {
    background: #fff4f5;
  }
  .sign-step3 {
    background: #fff7eb;
    .pay-success {
      color: #1dbf60;
      font-size: 20px;
      font-weight: bold;
    }
  }
  .sign-step4 {
    background: #edfff8;
    .sign-up-btn {
      margin-left: 0;
      margin-top: 5px;
    }
  }
  .sign-step5 {
    background: #f1f3fe;
    .sign-up-btn {
      margin-left: 0;
      margin-top: 5px;
    }
  }
  .sign-step1:after {
    border-color: transparent transparent #f1f3fe transparent;
    left: 68px;
    top: -20px;
  }
  .sign-step2:after {
    border-color: transparent transparent #fff4f5 transparent;
    left: 268px;
    top: -20px;
  }
  .sign-step3:after {
    border-color: transparent transparent #fff7eb transparent;
    left: 468px;
    top: -20px;
  }
  .sign-step4:after {
    border-color: transparent transparent #edfff8 transparent;
    left: 668px;
    top: -20px;
  }
  .sign-step5:after {
    border-color: transparent transparent #f1f3fe transparent;
    left: 39px;
    top: -20px;
  }
  .sign-step:after {
    width: 0;
    height: 0;
    border-width: 12px;
    border-style: solid;
    position: absolute;
    content: " ";
  }
  .sign-step {
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    height: 80px;
    border-radius: 8px;
    padding: 0 24px;
    position: relative;
  }
}

/* @media screen and (max-width: 1600px) {
  .step-item-spot {
    // margin: 0 20px !important;
  }
} */
</style>
